<template>
  <div class="app-main-content bill-overseas-s-center-view">
    <div
      class="main-content"
      type="primary"
    >
      <query-bill-actual-amount-condition
        ref="queryBillActualAmountCondition"
      >
        <template slot="operations">
          <div style="float: left;">
            <el-button style="margin-left: 10px" type="primary" @click="toQuery()">
              {{ $t('CargoMsg.Cargo_Query') }}
            </el-button>
            <el-button type="primary" @click="sendOfficeBtnClickHandler()">{{ $t('CargoMsg.Cargo_SettlementNotice') }}</el-button>
            <el-button type="primary" @click="viewDetailBtnClickHandler()">{{ $t('CargoMsg.Cargo_ViewDetail') }}</el-button>
            <el-button type="primary" @click="sendDLClickHandler()">{{ $t('CargoMsg.Cargo_NotifyHq') }}</el-button>
            <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
          </div>
        </template>
      </query-bill-actual-amount-condition>
    </div>
    <bill-actual-amount-grid
      config-module="410015204"
      :row-data="rowData"
      :filter="filter"
      :grid-options="gridOptions"
    />
    <bill-notice-result-window
      v-if="billNoticeResultWindow.visible"
      :visible="billNoticeResultWindow.visible"
      :select-items="billNoticeResultWindow.selectItems"
      @close="billNoticeResultWindow.visible = false"
      @refresh="toQuery"
    />
    <bill-actual-amount-detail-window
      v-if="billActualAmountDetailWindow.visible"
      :visible="billActualAmountDetailWindow.visible"
      :actual-amount="billActualAmountDetailWindow.actualAmount"
      @close="billActualAmountDetailWindow.visible = false"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import BillOverseasSCenterGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSCenterGrid'
import QueryBillActualAmountCondition from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillActualAmountCondition'
import BillActualAmountGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billActualAmountGrid'
import { queryActualAmount, sendHQOfficeEmail } from '@/api/clearing/actualAmount'
import BillNoticeResultWindow from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/billNoticeResultWindow'
import BillActualAmountDetailWindow
  from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/billActualAmountDetailWindow'
export default {
  name: 'BillActualAmount',
  components: { BillActualAmountDetailWindow, BillNoticeResultWindow, BillActualAmountGrid, QueryBillActualAmountCondition, BillOverseasSCenterGrid, AmountSumMaster },
  data() {
    return {
      fullscreenLoading: null,
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      selectRow: null,
      billNoticeResultWindow: {
        visible: false,
        selectItems: []
      },
      billActualAmountDetailWindow: {
        visible: false,
        actualAmount: {}
      },
      filter: {
        pageNum: 1,
        pageSize: 100
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        }
      }
    }
  },
  methods: {
    toQuery() {
      const option = this.$refs['queryBillActualAmountCondition'].getSearchOption()
      if (option.isMerge && !option.hasOwnProperty('accountId')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      option['oversea'] = true
      option['limit'] = this.filter.pageSize
      this.fullscreenLoading = getLoading()
      queryActualAmount(option).then(res => {
        this.rowData = res.data
        this.loadingEnd()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
      this.selectRow = null
    },
    sendOfficeBtnClickHandler() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      let isAllSend = false
      for (const ac of selectRows) {
        for (const ch of ac.clearHistory) {
          if (ch.confirmState === 0) {
            isAllSend = true
            break
          }
        }
      }
      if (!isAllSend) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllBillingHasBeenSentToBranches'))
        return
      }
      this.billNoticeResultWindow.visible = true
      this.billNoticeResultWindow.selectItems = selectRows
    },
    resetSearch() {
      this.$refs['queryBillActualAmountCondition'].resetSearch()
    },
    sendDLClickHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmAndNotityHQ'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        sendHQOfficeEmail().then(res => {
          this.fullscreenLoading.close()
          if (res.data === 'ok') {
            this.$message.success(this.$t('CargoMsg.sendEmailSuccess'))
          } else if (res.data !== 'fail') {
            this.$message.warning(res.data)
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_SendFailed'))
          }
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    viewDetailBtnClickHandler() {
      const selectRow = this.selectRow
      if (!selectRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      this.billActualAmountDetailWindow.actualAmount = selectRow
      this.billActualAmountDetailWindow.visible = true
    },
    onGridRowClickedEvent(event) {
      this.selectRow = event.data
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
